import React from 'react';
import { StyleSheet, View } from 'react-native';
import { AnimatedCircularProgress } from 'utils/packages/circularProgress';
import Button from 'design-system/Button';
import ModalHandle from 'design-system/ModalHandle';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { formatAmount } from 'utils/formatting';
import Modal from 'utils/packages/Modal';
import useColors from 'hooks/useColors';
const OverLimitModal = ({ usedAmount = 0, currentLimit = 0, tryingToTransferAmount = 0, onIncreaseLimitPress, }) => {
    const colors = useColors();
    return (<View>
      <ModalHandle />
      <Spacer h={56}/>
      <Text Text-24 centered>
        Bank Transfers
      </Text>
      <Spacer h={8}/>
      <Text TextThin-14 Gray centered>{`This payment will go over your monthly limit of £${currentLimit}. Upgrade to the next Premium plan to increase the limit.`}</Text>
      <Spacer h={34}/>
      <AnimatedCircularProgress style={styles.donutContainer} size={rem(216)} width={rem(16)} backgroundWidth={rem(10)} fill={((usedAmount + tryingToTransferAmount) / currentLimit) * 100} tintColor={colors.gradients.ultimate.colors[0]} backgroundColor={colors.background.dark} rotation={0}>
        {() => (<>
            <Text Numbers-36>{formatAmount(usedAmount + tryingToTransferAmount, 'GBP')}</Text>
            <Text TextThin-14 Gray>{`of £${currentLimit}`}</Text>
          </>)}
      </AnimatedCircularProgress>
      <Spacer h={64}/>
      <Button brandReversed title="No, thanks" onPress={() => {
            Modal.hide();
        }}/>
      <Spacer h={16}/>
      <Button brand title="Increase limit" onPress={onIncreaseLimitPress}/>
    </View>);
};
const styles = StyleSheet.create({
    donutContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
    },
});
export default OverLimitModal;
